export enum AuthenticationType {
  Oidc = 1,
  Adfs = 3,
  OidcCredem = 4,
}

export enum OIDCType {
  GAW = 'oidcSupport',
  oidcCredem = 'credemISAMSupport',
}
